export const FilterTypes = {
    PRODUCTION_LINES        : 'productionLinesFilter',
    REFERENCES              : 'referencesFilter',
    ORDER_REFERENCE         : 'orderReferenceFilter',
    BATCH                   : 'batchFilter',
    CARGO_DATE              : 'cargoDateFilter',
    ORDER                   : 'orderFilter',
    CLIENT                  : 'clientFilter',
}
